import styled from '@emotion/styled';
import { TextStyle } from '../../../styles/variables/mixins';
import { Colors } from '../../../styles/variables/colors';
import { Variables } from '../../../styles/variables/variables';
import { ReactComponent as CrossSimpleIconIcons } from 'assets/icons/cross-simple.svg';
import IconBtnIcon from 'components/common/IconBtn';

const { darkGray, white } = Colors;
const { assistant } = Variables;

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    column-gap: 1.5rem;
    margin-top: 2.75rem;

    @media screen and (max-width: 580px) {
        margin-top: 1.75rem;
        column-gap: 1rem;
    }
`;

export const CrossSimpleIcon = styled(CrossSimpleIconIcons)`
    fill: ${darkGray};
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding: 32px 24px;
    width: 100%;
    height: 100%;
    ${TextStyle({ fontSize: '15px', fontWeight: '400', color: darkGray, fontFamily: assistant })};
    font-style: normal;
    line-height: 20px;
`;

export const IconBtn = styled(IconBtnIcon)`
    height: 24px;
    width: 24px;
    font-family: Assistant, sans-serif;
    font-size: 15px;
    color: rgb(40, 40, 40);
`;

export const Modal = styled.div`
    padding: 20px 20px;
    position: relative;
    width: 80%;
    height: 100%;
    background: ${white};
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.03);
    border-radius: 4px;
    overflow: hidden;

    :focus-visible {
        outline: none;
    }
`;

export const ModalButtonWrapper = styled.div`
    position: absolute;
    top: 12px;
    right: 12px;
`;

export const ModalWrapper = styled.div<{ mobile: boolean }>`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    overflow: auto;
    display: block;
    max-width: 650px;
    width: 100%;
    margin-left: ${({ mobile }) => (mobile ? '35px' : '65px')};
`;

export const Text = styled.p`
    ${TextStyle({ fontSize: '17px', fontWeight: '600', color: darkGray, fontFamily: assistant })};
    text-align: center;
`;

export const Warning = styled.p`
    ${TextStyle({
        fontSize: '18px',
        fontWeight: '600',
        color: Colors.red,
        fontFamily: Variables.assistant,
    })};
    text-align: center;
`;
